export const getLastMessages = (state) => state.lastmessages